module.exports = __webpack_public_path__ + "media/images/login/btn_demo-eff7a6c4d8325b130753224bcd921dbb.png";